import type { PermissionName } from 'c-sdk';
import type { User } from 'c-entity-types';
import userHasPermissions from 'c-auth-module/Lib/userHasPermissions';

const userHasAllPermissions = (user: User, permissions: PermissionName[]) =>
    userHasPermissions(user, permissions).length >= permissions.length;

export default userHasAllPermissions;
